// Konfiguracja trybu aplikacji (2026-07-23, audyt UX Tier 1).
//
// SALES_ENABLED — czy pokazywać elementy sprzedażowe: plany, ceny, przyciski
// "Kup"/"Przejdź na Pro", checkout Stripe, twardy paywall przy limicie tokenów.
//
// DOMYŚLNIE FALSE. Powód: na obecnym etapie system NIE jest w sprzedaży — trwają
// testy z garstką zaufanych adwokatów, a Stripe to placeholder (klucze z .env.example).
// Każdy CTA zakupowy prowadziłby więc do martwego checkoutu i psuł zaufanie testera.
//
// JAK WŁĄCZYĆ SPRZEDAŻ (gdy podłączycie realne konto Stripe):
//   ustaw  REACT_APP_SALES_ENABLED=true  w env frontendu i przebuduj (craco build).
// Do tego czasu UI sprzedażowe jest ukryte, a limit tokenów pokazuje neutralny
// komunikat zamiast wyrzucać usera na stronę /suspended.
export const SALES_ENABLED = process.env.REACT_APP_SALES_ENABLED === "true";
